import Vue from "vue";
import App from "./App.vue";
import wb from "./registerServiceWorker";
// import VueQuagga from 'vue-quaggajs';
// import store from './store';

// register component 'v-quagga'
// Vue.use(VueQuagga);

Vue.config.productionTip = false;

Vue.prototype.$workbox = wb;

new Vue({
// store,
  render: h => h(App)
}).$mount("#app");
